export const HOME = { label: 'Home', url: '/' };
export const CONVERSION_RATES_HOME = {
  label: 'Conversion Rates',
  url: '/conversion-rates',
};

// Paths
export const MCC_RATES = '/conversion-rates/mcc/rates';
export const LP_RATES = '/conversion-rates/loyalty-points/rates';
export const LP_CONFIG = '/conversion-rates/loyalty-points/config';

// Breadcrumbs
export const viewMCCRates = [
  HOME,
  CONVERSION_RATES_HOME,
  { label: 'MCC', url: MCC_RATES },
];

export const viewLPRates = [
  HOME,
  CONVERSION_RATES_HOME,
  { label: 'Loyalty Points', url: LP_RATES },
];

export const viewLPConfig = [
  HOME,
  CONVERSION_RATES_HOME,
  { label: 'Loyalty Config', url: LP_CONFIG },
];
